import type { IconProps } from './types';

export const ArrowNarrowUpRightIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M4.45312 20.3906L19.5469 5.29688" stroke={color} strokeWidth="1.5" />
      <path d="M8.8125 5.29688H19.5469V16.0312" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
